import { render, staticRenderFns } from "./static-tabs.vue?vue&type=template&id=29b83418&scoped=true&"
import script from "./static-tabs.vue?vue&type=script&lang=js&"
export * from "./static-tabs.vue?vue&type=script&lang=js&"
import style0 from "./static-tabs.vue?vue&type=style&index=0&id=29b83418&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b83418",
  null
  
)

export default component.exports